export default __webpack_public_path__ + "static/meet-7120df2fb92482eb201076688f49adfb.png";